// Fetch Custom Views
export const FETCH_CUSTOM_VIEWS_REQUEST = 'FETCH_CUSTOM_VIEWS_REQUEST';
export const FETCH_CUSTOM_VIEWS_SUCCESS = 'FETCH_CUSTOM_VIEWS_SUCCESS';
export const FETCH_CUSTOM_VIEWS_FAILURE = 'FETCH_CUSTOM_VIEWS_FAILURE';

// Toggle Custom View Status
export const TOGGLE_CUSTOM_VIEW_STATUS_REQUEST = 'TOGGLE_CUSTOM_VIEW_STATUS_REQUEST';
export const TOGGLE_CUSTOM_VIEW_STATUS_SUCCESS = 'TOGGLE_CUSTOM_VIEW_STATUS_SUCCESS';
export const TOGGLE_CUSTOM_VIEW_STATUS_FAILURE = 'TOGGLE_CUSTOM_VIEW_STATUS_FAILURE';

// Delete Custom View
export const DELETE_CUSTOM_VIEW_REQUEST = 'DELETE_CUSTOM_VIEW_REQUEST';
export const DELETE_CUSTOM_VIEW_SUCCESS = 'DELETE_CUSTOM_VIEW_SUCCESS';
export const DELETE_CUSTOM_VIEW_FAILURE = 'DELETE_CUSTOM_VIEW_FAILURE';

// Fetch Rad Custom View
export const FETCH_RAD_CUSTOM_VIEW_REQUEST = 'FETCH_RAD_CUSTOM_VIEW_REQUEST';
export const FETCH_RAD_CUSTOM_VIEW_SUCCESS = 'FETCH_RAD_CUSTOM_VIEW_SUCCESS';
export const FETCH_RAD_CUSTOM_VIEW_FAILURE = 'FETCH_RAD_CUSTOM_VIEW_FAILURE';

// Fetch Custom View Share Dropdown in AddRadCustomViewModal
export const FETCH_CUSTOM_VIEW_SHARE_DROPDOWN_REQUEST = 'FETCH_CUSTOM_VIEW_SHARE_DROPDOWN_REQUEST';
export const FETCH_CUSTOM_VIEW_SHARE_DROPDOWN_SUCCESS = 'FETCH_CUSTOM_VIEW_SHARE_DROPDOWN_SUCCESS';
export const FETCH_CUSTOM_VIEW_SHARE_DROPDOWN_FAILURE = 'FETCH_CUSTOM_VIEW_SHARE_DROPDOWN_FAILURE';

// Save Shared Custom View
export const SAVE_SHARED_CUSTOM_VIEW_REQUEST = 'SAVE_SHARED_CUSTOM_VIEW_REQUEST';
export const SAVE_SHARED_CUSTOM_VIEW_SUCCESS = 'SAVE_SHARED_CUSTOM_VIEW_SUCCESS';
export const SAVE_SHARED_CUSTOM_VIEW_FAILURE = 'SAVE_SHARED_CUSTOM_VIEW_FAILURE';

// Provider DD List
export const GET_RADIOLOGIST_ALL_DD_LIST_REQUEST = 'GET_RADIOLOGIST_ALL_DD_LIST_REQUEST';
export const GET_RADIOLOGIST_ALL_DD_LIST_SUCCESS = 'GET_RADIOLOGIST_ALL_DD_LIST_SUCCESS';
export const GET_RADIOLOGIST_ALL_DD_LIST_FAILURE = 'GET_RADIOLOGIST_ALL_DD_LIST_FAILURE';

export const SAVE_RAD_CUSTOM_VIEW_REQUEST = 'SAVE_RAD_CUSTOM_VIEW_REQUEST';
export const SAVE_RAD_CUSTOM_VIEW_SUCCESS = 'SAVE_RAD_CUSTOM_VIEW_SUCCESS';
export const SAVE_RAD_CUSTOM_VIEW_FAILURE = 'SAVE_RAD_CUSTOM_VIEW_FAILURE';
export const SAVE_RAD_CUSTOM_VIEW_RESET = 'SAVE_RAD_CUSTOM_VIEW_RESET';